module.exports = __webpack_public_path__ + "static/media/spinner.87bd3959.svg";